<!-- src/components/StatusBlockCircle.vue -->

<template>
  <a class="w-5 h-5 block cursor-pointer"
     :class="{ 'ring ring-current ring-offset-2': selected }"
     :style="{ background: color, color: ringColor }"
     :aria-label="color"
     @click.prevent="$emit('click')"></a>
</template>

<script>
import HexToHSL from "../../mixins/HexToHSL";

export default {
  mixins: [HexToHSL],
  props: ['selected', 'color'],
  data() {
    const hsl = this.hexToHsl(this.color);
    return {
      ringColor: `hsl(${hsl.h} ${hsl.s}% ${hsl.l}% / 75%)`
    }
  }
}
</script>
